import { useCallback, useState } from 'react';

import { SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import { motorwayPayPageEvents } from 'Services/analytics/events/paymentEvents/motorwayPayPageEvents';

import type { DiscoverMWPayModalState } from '../DiscoverMWPay.types';

import type { useModalJoinMotorwayPayParams, useModalJoinMotorwayPayReturn } from './ModalJoinMotorwayPay.types';

export const useModalJoinMotorwayPay = ({
	defaultState = 'closed',
}: useModalJoinMotorwayPayParams = {}): useModalJoinMotorwayPayReturn => {
	const [state, setState] = useState<DiscoverMWPayModalState>(defaultState);
	const closeModal = useCallback(() => {
		motorwayPayPageEvents({
			name: 'Join Motorway Pay modal closed',
			schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
			version: SNOWPLOW_EVENTS.CLICK.VERSION,
		});
		setState('closed');
	}, []);

	const openModal = useCallback(() => {
		motorwayPayPageEvents({
			name: 'Join Motorway Pay modal open',
			schemaName: SNOWPLOW_EVENTS.POPUP_APPEAR.SCHEMA,
			version: SNOWPLOW_EVENTS.POPUP_APPEAR.VERSION,
		});
		setState('open');
	}, []);

	return {
		closeModal,
		openModal,
		state,
	};
};
